import { App } from '@capacitor/app'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setCustomer } from '../redux/customerSlice'
import request from '../request'
import { selectCustomer } from '../store'

const fourthyHInMs = 40 * 60 * 60 * 1000

export default function useAppResume() {
  const customer = useSelector(selectCustomer)
  const dispatch = useDispatch()

  useEffect(() => {
    App.addListener('resume', () => {
      if (customer?.lastFetched) {
        const diff = new Date().getTime() - customer.lastFetched

        if (diff > fourthyHInMs) {
          dispatch(setCustomer(null))
          request('/customer').then((data: Customer) => dispatch(setCustomer(data)))
        }
      }
    })

    return () => {
      App.removeAllListeners()
    }
  }, [customer])
}
